import { getRuntimePageBasePath } from '@/utils/path';
import { getRuntimeWildcardEditorHost, parseWildcardHost } from '@/utils/wildcardHost';

export function getFlowJobPageURL({
  projectId = window.w.projectId,
  flowId,
  jobId = '',
  envId = window.w.env,
  branchId, // = envId === 'dev' && window.RUNTIME_CONFIGS.branch,  // 暂时不考虑填入默认值，避免奇怪问题
  hashData = '',
}) {
  const url = new URL(window.location.href);
  const isCustomBranch = envId === 'dev' && branchId && branchId !== 'master';
  // 泛域名打不开分支长路径，改挂到编辑端域名。
  if (isCustomBranch && parseWildcardHost(url.host)) {
    const editorOrigin = getRuntimeWildcardEditorHost();
    if (editorOrigin) {
      const editorUrl = new URL(editorOrigin);
      url.protocol = editorUrl.protocol;
      url.host = editorUrl.host;
    }
  }
  const basePath = getRuntimePageBasePath({
    env: envId,
    projectId,
    branch: branchId,
    host: url.host,
  });
  url.pathname = `${basePath}/wuji/workflow/flow/${encodeURIComponent(flowId)}`;
  url.search = '';
  url.searchParams.set('projectId', projectId);
  if (jobId) url.searchParams.set('jobId', jobId);
  if (hashData)url.hash = hashData;
  return url.toString();
}
